import { createFileRoute } from "@tanstack/react-router";

import TaxReadinessPage from "@/features/dashboard/pages/tax-readiness";

export const Route = createFileRoute("/(app)/dashboard/tax-readiness")({
  component: () => <TaxReadinessPage />,
});
